{
    "title": "JSON schema for KLPMS product",
    "$schema": "https://degeetia.ee/schema/klpms/product",
    "type": "object",
    "properties": {
        "version": {
            "type": "integer",
            "title": "Product file version",
            "enum": [3]
        },
        "lineCount": {
            "type": "integer",
            "title": "Line count",
            "enum": [4, 5]
        },
        "codeVariant": {
            "type": "string",
            "title": "Product code and variant"
        },
        "scanCode": {
            "type": "string",
            "title": "Product SCAN code"
        },
        "description": {
            "type": "string",
            "title": "Product description"
        },
        "measurementLines": {
            "type": "array",
            "title": "Measurement lines",
            "items": {
                "minItems": 3,
                "maxItems": 5,
                "type": "object",
                "properties": {
                    "lineLength": {
                        "type": "integer",
                        "title": "Line length"
                    },
                    "endpoints": {
                        "type": "array",
                        "title": "Endpoints",
                        "items": {
                            "minItems": 2,
                            "maxItems": 2,
                            "type": "object",
                            "properties": {
                                "x": {
                                    "type": "integer",
                                    "title": "X coordinate"
                                },
                                "y": {
                                    "type": "integer",
                                    "title": "Y coordinate"
                                },
                                "z": {
                                    "type": "integer",
                                    "title": "Z coordinate"
                                },
                                "slopeX": {
                                    "type": "integer",
                                    "title": "Measuring angle in X-axis"
                                },
                                "slopeY": {
                                    "type": "integer",
                                    "title": "Measuring angle in Y-axis"
                                },
                                "printOffset": {
                                    "type": "integer",
                                    "title": "Print offset from the edge"
                                }
                            }
                        }
                    },
                    "nominals": {
                        "type": "array",
                        "title": "Nominal points",
                        "items": {
                            "type": "object",
                            "properties": {
                                "name": {
                                    "type": "string",
                                    "title": "Name",
                                    "enum": ["A1", "B1", "C1", "A2", "B2", "C2", "A3", "B3", "C3", "A4", "B4", "C4", "A5", "B5", "C5", "P50", "P100", "P150", "P200", "P250", "P300"]
                                },
                                "value": {
                                    "type": "integer",
                                    "title": "Nominal value"
                                },
                                "upperTolerance1": {
                                    "type": "integer",
                                    "title": "Upper tolerance 1"
                                },
                                "upperTolerance2": {
                                    "type": "integer",
                                    "title": "Upper tolerance 2"
                                },
                                "lowerTolerance1": {
                                    "type": "integer",
                                    "title": "Lower tolerance 1"
                                },
                                "lowerTolerance2": {
                                    "type": "integer",
                                    "title": "Lower tolerance 2"
                                },
                                "distance": {
                                    "type": "integer",
                                    "title": "Distance from the glass edge"
                                },
                                "correction": {
                                    "type": "integer",
                                    "title": "Correction"
                                },
                                "isAdas": {
                                    "type": "boolean",
                                    "title": "Is ADAS window point"
                                },
                                "show": {
                                    "type": "boolean",
                                    "title": "Show nominal in measurements screen"
                                }
                            }
                        }
                    },
                    "angles": {
                        "type": "array",
                        "title": "Nominal angles",
                        "items": {
                            "type": "object",
                            "properties": {
                                "name": {
                                    "type": "string",
                                    "title": "Name",
                                    "enum": ["ANGLE"]
                                },
                                "value": {
                                    "type": "integer",
                                    "title": "Nominal value"
                                },
                                "upperTolerance1": {
                                    "type": "integer",
                                    "title": "Upper tolerance 1"
                                },
                                "upperTolerance2": {
                                    "type": "integer",
                                    "title": "Upper tolerance 2"
                                },
                                "lowerTolerance1": {
                                    "type": "integer",
                                    "title": "Lower tolerance 1"
                                },
                                "lowerTolerance2": {
                                    "type": "integer",
                                    "title": "Lower tolerance 2"
                                },
                                "point1": {
                                    "type": "string",
                                    "title": "First point name",
                                    "enum": ["C2", "C3", "P50", "P100", "P150", "P200", "P250", "P300"]
                                },
                                "point2": {
                                    "type": "string",
                                    "title": "Second point name",
                                    "enum": ["C2", "C3", "P50", "P100", "P150", "P200", "P250", "P300"]
                                }
                            }
                        }
                    }
                }
            }
        },
        "glassThickness": {
            "type": "integer",
            "title": "Glass thickness"
        },
        "measuringProfileClass": {
            "type": "integer"
        },
        "measuringProfilePrint": {
            "type": "integer"
        },
        "diffX": {
            "type": "integer"
        },
        "diffY": {
            "type": "integer"
        },
        "offsetX": {
            "type": "integer"
        },
        "offsetY": {
            "type": "integer"
        },
        "distance": {
            "type": "integer"
        },
        "offsetE": {
            "type": "integer"
        },
        "lineUpper": {
            "type": "array",
            "items": {
                "type": "integer"
            }
        },
        "lineLower": {
            "type": "array",
            "items": {
                "type": "integer"
            }
        },
        "pX": {
            "type": "array",
            "items": {
                "type": "integer"
            }
        },
        "pY": {
            "type": "array",
            "items": {
                "type": "integer"
            }
        },
        "rotatedLine": {
            "type": "boolean"
        },
        "toleranceMiddle1": {
            "type": "integer"
        },
        "toleranceMiddle2": {
            "type": "integer"
        },
        "toleranceEdge1": {
            "type": "integer"
        },
        "toleranceEdge2": {
            "type": "integer"
        },
        "mirrored": {
            "type": "boolean"
        },
        "rotatedFirst": {
            "type": "boolean"
        },
        "rotatedLast": {
            "type": "boolean"
        },
        "rotated": {
            "type": "boolean"
        },
        "angle": {
            "type": "object",
            "properties": {
                "name": {
                    "type": "string",
                    "title": "Name"
                },
                "value": {
                    "type": "integer",
                    "title": "Nominal value"
                },
                "upperTolerance1": {
                    "type": "integer",
                    "title": "Upper tolerance 1"
                },
                "upperTolerance2": {
                    "type": "integer",
                    "title": "Upper tolerance 2"
                },
                "lowerTolerance1": {
                    "type": "integer",
                    "title": "Lower tolerance 1"
                },
                "lowerTolerance2": {
                    "type": "integer",
                    "title": "Lower tolerance 2"
                }
            }
        },
        "adasAreas": {
            "type": "array",
            "title": "ADASA Area definitions",
            "items": {
                "type": "object",
                "properties": {
                    "distance": {
                        "type": "integer",
                        "title": "ADAS area definition distnce from the edge of glass (mm, scaled 10x)"
                    },
                    "type": {
                        "type": "integer",
                        "title": "ADAS area definition type (0=Glass, 1=Print, 2=Raster (for future use), 3=Heatwire (for future use))",
                        "enum": [0, 1, 2, 3]
                    }
                }
            }
        }
    }
}
